/** Max length for a public booking slug path segment. */
export const MAX_BOOKING_SLUG_LENGTH = 64

/** First path segments reserved for the provider app / system — never a booking slug. */
export const RESERVED_BOOKING_SLUGS = new Set([
  'booking',
  'bookings',
  'settings',
  'login',
  'my-bookings',
  'guests',
  'guest-details',
  'calendar',
  'onboarding',
  'registration',
  'registration-provider',
  'registration-client',
  'notifications',
  'verification-code',
  'sitemap',
  'api',
  'aiassist',
  'ai-assistant',
  'months',
  'weeklikip',
  'week-day-picker-view',
  'assets',
  'static',
])

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

/** Normalize a display name into a URL slug candidate (may be empty). */
export function slugifyBookingName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_BOOKING_SLUG_LENGTH)
    .replace(/-+$/g, '')
}

export function isReservedBookingSlug(slug: string): boolean {
  return RESERVED_BOOKING_SLUGS.has(slug)
}

/** True when slug matches charset/length and is not reserved. */
export function isValidBookingSlug(slug: string): boolean {
  if (!slug || slug.length > MAX_BOOKING_SLUG_LENGTH) {
    return false
  }
  if (isReservedBookingSlug(slug)) {
    return false
  }
  return SLUG_PATTERN.test(slug)
}

/**
 * Next candidate when `base` (or `base-n`) is taken.
 * `base` → `base-2` → `base-3` …
 */
export function nextBookingSlugCandidate(base: string, attempt: number): string {
  if (attempt <= 1) {
    return base.slice(0, MAX_BOOKING_SLUG_LENGTH)
  }
  const suffix = `-${attempt}`
  const maxBase = MAX_BOOKING_SLUG_LENGTH - suffix.length
  return `${base.slice(0, Math.max(1, maxBase))}${suffix}`
}

/** Public path handle: prefer human slug, else Convex profile id. */
export function bookingHandleFromProfile(profile: { _id: string; bookingSlug?: string | null }): string {
  const slug = profile.bookingSlug?.trim()
  return slug && slug.length > 0 ? slug : profile._id
}
